import { render, staticRenderFns } from "./HyroxSimulationAdmin.vue?vue&type=template&id=c8061aba&scoped=true"
import script from "./HyroxSimulationAdmin.vue?vue&type=script&lang=js"
export * from "./HyroxSimulationAdmin.vue?vue&type=script&lang=js"
import style0 from "./HyroxSimulationAdmin.vue?vue&type=style&index=0&id=c8061aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8061aba",
  null
  
)

export default component.exports